import React, { useEffect, useState } from 'react';
import { Accordion } from '../../../../../../components';
import { ChannelBox } from '../../../../components/channel/box';
import { useDevicesAndChannelsContext } from '../../../../context/devices-and-channels';
import { ChannelType } from '../../../../types';

type Item = { channels: ChannelType[]; label: string };

type GroupChannelsProps = {
  items: Item[];
  defaultChannels: string[] | undefined;
  handleSelectedChannel: (items: string[]) => void;
};

const GroupChannels: React.FC<GroupChannelsProps> = ({ items, handleSelectedChannel, defaultChannels }) => {
  const { channelList } = useDevicesAndChannelsContext();
  const [selectedChannels, setSelectedChannels] = useState<string[]>([]);

  useEffect(() => {
    setSelectedChannels(
      (channelList.filter((channel) => channel?.id && defaultChannels?.includes(channel.id)) as ChannelType[]).map(
        (channel) => channel.id,
      ),
    );
  }, [channelList, defaultChannels]);

  const handleChannelOnChange = (id: string, value: boolean) => {
    if (value && !selectedChannels.includes(id)) {
      const values = [...selectedChannels, id];
      handleSelectedChannel(values);
      setSelectedChannels(values);
    }
    if (!value && selectedChannels.includes(id)) {
      const values = selectedChannels.filter((v) => v !== id);
      handleSelectedChannel(values);
      setSelectedChannels(values);
    }
  };

  const itemsWithElements = items.filter((item) => item.channels.length > 0);

  return (
    <ul className="form-devices">
      {itemsWithElements.map((item: Item) => {
        const selectedItems = item.channels.filter((element) => selectedChannels.includes(element.id)).length;

        return (
          <li key={item.label}>
            <Accordion
              kind="custom"
              title={item.label}
              selectedItems={selectedItems}
              totalItems={item.channels.length}
              expanded={itemsWithElements.length === 1}
            >
              <ul className="grid-list-24">
                {item.channels?.map((channel: ChannelType) => (
                  <ChannelBox
                    key={channel.id}
                    channel={channel}
                    isListItem
                    isCheckbox
                    checked={selectedChannels.includes(channel.id)}
                    onChannelToggle={handleChannelOnChange}
                    noRedirect
                  />
                ))}
              </ul>
            </Accordion>
          </li>
        );
      })}
    </ul>
  );
};

export default GroupChannels;
